<bit-dialog
  dialogSize="large"
  [loading]="loading"
  [title]="'trustOrganization' | i18n"
  [subtitle]="params.name"
>
  <ng-container bitDialogContent>
    <p bitTypography="body1">
      {{ "orgTrustWarning1" | i18n }}
      <br />
      <br />
      {{ "fingerprintPhrase" | i18n }} <code>{{ fingerprint }}</code>
    </p>
  </ng-container>
  <ng-container bitDialogFooter>
    <button buttonType="primary" bitButton bitFormButton type="button" (click)="submit()">
      <span>{{ "trust" | i18n }}</span>
    </button>
    <button bitButton bitFormButton buttonType="secondary" type="button" bitDialogClose>
      {{ "doNotTrust" | i18n }}
    </button>
  </ng-container>
</bit-dialog>
